import { render } from "./trainer.vue?vue&type=template&id=6079ec9e&ts=true"
import script from "./trainer.vue?vue&type=script&lang=ts"
export * from "./trainer.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__